import {Component, OnInit} from '@angular/core';
import {LoaderService} from "../../service/loader.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [
    NgIf
  ]
})
export class SpinnerComponent implements OnInit {
  constructor(public loader: LoaderService) {}

  ngOnInit(): void {
  }

}
